import { reactive } from 'vue'

// useToast.js와 동일한 패턴: 모듈 스코프의 reactive 싱글턴 상태를
// app.vue에 상시 마운트된 <ErrorDialog />가 구독한다 (전역 서비스처럼 어디서든 show() 호출 가능)
const state = reactive({ visible: false, header: '오류', message: '', errors: [] })

export default function () {
  const show = ({ header, message, errors } = {}) => {
    state.header = header ?? '오류'
    state.message = message ?? ''
    state.errors = errors ?? []
    state.visible = true
  }

  return { state, show }
}
